export default __webpack_public_path__ + "static/media/userManual.8e3b09c4.svg";